module.exports = __webpack_public_path__ + "static/title-c1bf1e1b87ebee21c154f76ce2c26131.png";